import { TABLEPAI, RBE_TABLE_HEADER } from "@/enums/pageEnum";
import { useTranslation } from "react-i18next";
import BasicTable from "@/components/BasicTable";
import {
  AlarmRbeColumns,
  RbeStatuses,
  LiftTcPfxBlkNumber,
} from "@/utils/commonConfig";

export default function RBE() {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <BasicTable
        filterTableFields={[
          { ...LiftTcPfxBlkNumber(t) },
          {
            field: "alarmStatus",
            label: t("alarmStatus"),
            component: "select",
            options: RbeStatuses(t),
            fieldProps: { style: { width: 180 } },
          },
          {
            field: "types",
            label: t("errorCode"),
            apiUrl: `${TABLEPAI.RBE_CODE}?view=RBE`,
            fieldProps: {
              mode: "multiple",
              style: { width: 180 },
              maxTagCount: "responsive",
            },
            component: "apiSelect",
          },
          { field: "lmdClientId", label: t("lMDID"), component: "text" },
          { field: "postalCode", label: t("postalCode"), component: "text" },
          { field: "date", label: t("setTime"), component: "timeRange" },
        ]}
        tableColsRender={AlarmRbeColumns({ t })}
        tableName="alarm/rbe"
        isShowCheckbox={false}
        editTableHeaderUrl={RBE_TABLE_HEADER}
        longPolling
        headerTitle={() => t("RBEList")}
        requestUrl={TABLEPAI.ALARM_RBE}
      />
    </div>
  );
}
